/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {AccountLink} from '@ion/core/src/types/entities';
import {GroupsFilterTree} from '@ion/dls/src/filters/GroupsFilterTree';
import {Filters, SCFilterProps} from '@ion/dls/src/types/types';
import {FilterParamsType} from '../types';

export interface GroupsFilterParamsType extends FilterParamsType {
  appliedSaveFilter?: string;
  updateTreeNodes?: (nodes: any) => void;
  updateKeys?: (keys: string[], type: string) => void;
  treeNodes?: any;
  treeKeys?: any;
  nodeKeys?: any;
  scFilterProps: SCFilterProps;
  currentGroup?: AccountLink;
  onMultiDropdownChecked?: Function;
  groupTreeRef?: any;
}

export const GroupsFilter = ({
  appliedSaveFilter,
  isPhone,
  globalGroup,
  accountHierarchy,
  toggleView,
  filterState,
  handleSubmit,
  globalGroupId,
  updateTreeNodes,
  onSelected,
  treeNodes,
  updateKeys,
  treeKeys,
  nodeKeys,
  assetLoading,
  onUpdateItemStored,
  cachedData,
  currentGroup,
  scFilterProps,
  groupTreeRef,
  onMultiDropdownChecked
}: GroupsFilterParamsType) => {
  const props = {
    assetLoading,
    appliedSaveFilter,
    cachedData,
    nodeKeys,
    onUpdateItemStored,
    treeKeys,
    treeNodes,
    scFilterProps,
    isMobileView : isPhone,
    account      : {
      globalGroup,
      accountHierarchy
    },
    assetFilterState  : filterState[Filters.assets],
    filterState       : filterState[Filters.groups],
    deviceFilterState : filterState[Filters.devices],
    name              : Filters.groups,
    onSelected,
    updateKeys,
    updateTreeNodes,
    onMultiDropdownChecked,
    onCancel          : toggleView,
    onMenuClose       : toggleView,
    onSubmit          : handleSubmit
  };
  return <GroupsFilterTree key={currentGroup} {...props} ref={groupTreeRef} />;
};
